import React from 'react';
import './career.css';

const CareerComponent = () => {
  return (
    <div className="careers-page">

      {/* Hero Section */}
      <section className="hero-section text-white text-center py-3">
        <div className="container">
          <h1 className=" fw-bold">Join the Loanontip Team</h1>
          <p className="lead mt-3 hero-subtext">
  Help us build smarter, faster lending solutions for India’s workforce.
</p>

        </div>
      </section>

      {/* Why Work With Us */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-4 fw-bold text-primary">Why Work With Us?</h2>
          <div className="row text-center">
            {[
              {
                title: 'Impactful Work',
                desc: 'Make a real difference by improving access to finance for salaried professionals across India.',
              },
              {
                title: 'Innovative Culture',
                desc: 'Be part of a tech-first team reimagining lending with the latest tools and technology.',
              },
              {
                title: 'Growth Opportunities',
                desc: 'We invest in our people. Grow your career through mentorship, learning, and leadership roles.',
              },
            ].map((item, index) => (
              <div key={index} className="col-md-4 mb-4">
                <div className="card border-0 h-100 shadow-sm p-4">
                  <h5 className="fw-bold">{item.title}</h5>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Application Form Section */}
      <section className="py-3">
        <div className="container">
          <h2 className="text-center mb-4 fw-bold text-primary">Submit Your Application</h2>
          <p className="text-center mb-5">
            If you're passionate about fintech and innovation, we'd love to hear from you!
          </p>

          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card border-0 shadow-lg rounded-4 p-4 mb-4">
                <div className="text-center mb-4">
                  <span className="fs-1 text-primary">
                    <i className="bi bi-person-badge"></i>
                  </span>
                  <h4 className="fw-bold mt-2 mb-1">Apply Now</h4>
                  <p className="mb-0">We'd love to know more about you!</p>
                </div>
                <form action="mailto:hr@dhanwalle.com" method="POST" encType="multipart/form-data">
  <div className="row">
    <div className="col-md-6 mb-3">
      <label htmlFor="name" className="form-label fw-semibold">Full Name</label>
      <input type="text" className="form-control form-control-lg rounded-3" id="name" name="name" required />
    </div>

    <div className="col-md-6 mb-3">
      <label htmlFor="email" className="form-label fw-semibold">Email</label>
      <input type="email" className="form-control form-control-lg rounded-3" id="email" name="email" required />
    </div>

    <div className="col-md-6 mb-3">
      <label htmlFor="phone" className="form-label fw-semibold">Phone Number</label>
      <input type="tel" className="form-control form-control-lg rounded-3" id="phone" name="phone" required />
    </div>

    <div className="col-md-6 mb-3">
      <label htmlFor="applyingFor" className="form-label fw-semibold">Applying for</label>
      <input type="text" className="form-control form-control-lg rounded-3" id="applyingFor" name="applyingFor" required />
    </div>

    <div className="col-md-6 mb-4">
      <label htmlFor="noticePeriod" className="form-label fw-semibold">Notice Period</label>
      <input type="text" className="form-control form-control-lg rounded-3" id="noticePeriod" name="noticePeriod" required />
    </div>

    <div className="col-md-6 mb-4">
      <label htmlFor="resume" className="form-label fw-semibold">Upload Resume</label>
      <input className="form-control form-control-lg rounded-3" type="file" id="resume" name="resume" required />
    </div>

    <div className="col-12 mb-4">
      <label htmlFor="message" className="form-label fw-semibold">Why do you want to join Loanontip?</label>
      <textarea className="form-control form-control-lg rounded-3" id="message" name="message" rows="4" required></textarea>
    </div>

    <div className="col-12">
      <button type="submit" className="btn w-100 fw-bold text-white apply-btn-gradient">
        <i className="bi bi-send me-2"></i>Submit Application
      </button>
    </div>
  </div>
</form>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-3 cta-section text-center text-white">
        <div className="container">
          <h2 className="fw-bold mb-3">Have questions before applying?</h2>
          <p className="mb-4">
            Reach out to us at{' '}
            <a href="mailto:hr@dhanwalle.com" className="text-white fw-bold">
              hr@dhanwalle.com
            </a>
          </p>
          
        </div>
      </section>
    </div>
  );
};

export default CareerComponent;
